import React, {useEffect, useState} from 'react';
import DateInfo from "../date-info/date-info";
import MechanicColumn from "../mechanic-data/mechanic-column";
import css from './Table.module.css';
import {Loader} from "../UI/loader/Loader";
import ScheduleService from "../../API/ScheduleService";
import {useFetching} from "../../hooks/useFetching";

export function getMechanicSeparatorIndex(employees) {
    const firstMechanicIndex = Array.isArray(employees)
        ? employees.findIndex(employee => String(employee?.employee_type || '').toUpperCase() === 'MEC')
        : -1;

    return firstMechanicIndex > 0 && employees[firstMechanicIndex - 1].employee_type === 'ADM'
        ? firstMechanicIndex
        : -1;
}

export function prepareEmployees(employees) {
    if (!Array.isArray(employees)) {
        return [];
    }

    return employees
        .map(employee => ({
            ...employee,
            employee_type: String(employee.employee_type || '').toUpperCase()
        }))
        .sort((left, right) => {
            const typeOrder = {ADM: 0, MEC: 1};
            return (typeOrder[left.employee_type] ?? 2) - (typeOrder[right.employee_type] ?? 2)
                || String(left.name || '').localeCompare(String(right.name || ''), 'ru');
        });
}

const Table = () => {
    /**
     * useEffect для получения сотрудников с бэка
     */
    const [employees, setEmployees] = useState([]);
    const [fetchEmployees, isLoading, employeesError] = useFetching(async () => {
        const response = await ScheduleService.getAll()
        setEmployees(prepareEmployees(response.data));
    });

    useEffect(() => {
        fetchEmployees().then(() => {
        });
    }, []);

    const refreshEmployees = async () => {
        try {
            await fetchEmployees();

            const response = await ScheduleService.getAll();
            setEmployees(prepareEmployees(response.data));
        } catch (error) {
            console.error("Ошибка при обновлении сотрудников:", error);
        }
    };

    const mechanicSeparatorIndex = getMechanicSeparatorIndex(employees);

    return (
        <div>
            {employeesError && <h1>Произошла ошибка {employeesError}!</h1>}
            {isLoading ? <div style={{display: 'flex', justifyContent: 'center', marginTop: 50}}><Loader/></div> :
                <div
                    className={css.table}
                    style={{'--mechanic-separator-index': mechanicSeparatorIndex}}
                >
                    <MechanicColumn employees={employees} mechanicSeparatorIndex={mechanicSeparatorIndex}/>
                    <DateInfo
                        employees={employees}
                        refreshEmployees={refreshEmployees}
                        mechanicSeparatorIndex={mechanicSeparatorIndex}
                    />
                </div>}
        </div>
    );
};

export default Table;
